// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8638 ? "070bff88" : chunkId) + "." + {"542":"fae98872d52e216b","1936":"69bbd866f3efd00d","3673":"6593415c9c4dde9e","5387":"e251ba24df53b68e","6268":"281e5338a7f62715","7020":"fb56b6066fa768bb","7127":"80ccff6a393046e4","8160":"fe3fe726c63b6f88","8638":"b8a0d699e00d5141"}[chunkId] + ".js";
};